import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import States from './States';

export default compose(withRouter)(States);
